import { useEffect, useState } from "react";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import AuthedImage from "@/components/AuthedImage";
import { Link } from "react-router-dom";

// Public materials do not require authentication or authed image
function PublicImg({ url, className }) {
  if (!url) return <div className={`bg-muted ${className}`}/>;
  return <img src={url} className={className} alt=""/>;
}

export default function PublicMaterialsPage() {
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState("all");

  useEffect(() => {
    api.get("/public/materials", { params: category !== "all" ? { category } : {} }).then((r) => setItems(r.data));
  }, [category]);

  const cats = ["all", "Timber Panels", "Feature Panels", "Cabinetry", "LED Lighting", "Electric Fireplaces"];

  return (
    <div className="min-h-screen bg-background" data-testid="public-materials-page">
      <PublicNav/>
      <div className="pt-32 pb-8 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="overline">Materials</div>
        <h1 className="font-serif font-light mt-3" style={{ fontSize: "clamp(44px, 6vw, 68px)", lineHeight: 1.05 }}>
          A curated palette.
        </h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">
          A selection of stones, timbers, panels and hardware we work with regularly. Every project is bespoke — this is a starting point, not a catalogue.
        </p>

        <div className="flex flex-wrap gap-2 mt-8">
          {cats.map((c) => (
            <button key={c} data-testid={`filter-mat-${c}`}
              onClick={() => setCategory(c)}
              className={`px-4 py-2 text-xs tracking-wide border ${category === c ? "bg-foreground text-background border-foreground" : "border-input text-muted-foreground hover:text-foreground"}`}>
              {c === "all" ? "All" : c}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {items.length === 0 ? (
          <div className="col-span-full text-muted-foreground text-sm">More materials will appear here as the studio publishes them. In the meantime, please <Link to="/enquiry" className="underline">tell us what you're imagining</Link>.</div>
        ) : items.map((p) => (
          <div key={p.id} data-testid={`public-material-${p.id}`}>
            <div className="aspect-square bg-muted overflow-hidden">
              {/* Public materials use an authed backend image if available, else nothing */}
              <div className="w-full h-full">{p.image_path ? <AuthedImage path={p.image_path} className="w-full h-full object-cover"/> : <div className="w-full h-full flex items-center justify-center text-[color:hsl(var(--accent))] font-serif text-2xl">·</div>}</div>
            </div>
            <div className="mt-3">
              <div className="overline text-[10px]">{p.brand || p.category}</div>
              <div className="font-serif text-lg mt-1">{p.name}</div>
              <div className="text-xs text-muted-foreground mt-1">{p.finish || p.colour || ""}</div>
            </div>
          </div>
        ))}
      </div>

      <PublicFooter/>
    </div>
  );
}
